module.exports = __webpack_public_path__ + "static/img/图层16.fbd4b41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cardSolution/图层16.png
// module id = TirX
// module chunks = 0